import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";

import { useLocation } from "react-router-dom";

import SalesReturn from "../SalesReturn/Invoice";
import SalesReturnRecord from "../SalesReturnRecord";
import SalesReturnVoucher from "../SalesReturnVoucher";

import { accessChecker } from "../../lib/functions"; 

const SalesReturnTabs = ({authInfo}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Sales Return Entry",
      key: "entry",
      value: "sales_return",
      children: (
        <>
          <SalesReturn  authInfo={authInfo}/>
        </>
      ),
    },
    {
      label: "Sales Return Record",
      key: "record",
      value: "sales_return_record",
      children: (
        <>
          <SalesReturnRecord />
        </>
      ),
    },
    {
      label: "Sales Return Voucher",
      key: "voucher",
      value: "sales_return_voucher",
      children: (
        <>
          <SalesReturnVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));
  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default SalesReturnTabs;
